import { LabelSize, LabelTheme } from 'common/types/types';

const styles: Record<LabelTheme, Record<LabelSize, string>> = {
  default: {
    s: 'text-xs font-bold mb-2 text-trueGray truncate ...',
  },
};

export default styles;
